<template>
  <Teleport to="body">
    <Transition name="ui-snackbar">
      <div
        v-if="modelValue"
        :class="['ui-snackbar', `ui-snackbar--${type}`]"
        role="status"
        aria-live="polite"
      >
        <span class="ui-snackbar__message">{{ message }}</span>
        <div class="ui-snackbar__actions">
          <button
            v-if="actionLabel"
            type="button"
            class="ui-snackbar__action"
            @click="handleAction"
          >
            {{ actionLabel }}
          </button>
          <button type="button" class="ui-snackbar__close" aria-label="Закрыть" @click="close">
            Закрыть
          </button>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    modelValue: boolean
    message: string
    type?: 'info' | 'success' | 'error' | 'warning'
    actionLabel?: string
  }>(),
  { type: 'info' },
)

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
  (e: 'action'): void
}>()

function close() {
  emit('update:modelValue', false)
}

function handleAction() {
  emit('action')
}
</script>

<style scoped>
.ui-snackbar {
  position: fixed;
  top: 16px;
  right: 16px;
  z-index: 2000;
  display: grid;
  gap: 8px;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  width: min(520px, calc(100vw - 32px));
  box-sizing: border-box;
}

.ui-snackbar--info {
  background: #e0f2fe;
  border-color: #0ea5e9;
  color: #0c4a6e;
}

.ui-snackbar--success {
  background: #dcfce7;
  border-color: #22c55e;
  color: #14532d;
}

.ui-snackbar--error {
  background: #fee2e2;
  border-color: #ef4444;
  color: #7f1d1d;
}

.ui-snackbar--warning {
  background: #fef3c7;
  border-color: #f59e0b;
  color: #78350f;
}

.ui-snackbar__message {
  min-width: 0;
  font: inherit;
  line-height: 1.45;
}

.ui-snackbar__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}

.ui-snackbar__action,
.ui-snackbar__close {
  flex-shrink: 0;
  padding: 4px 8px;
  font: inherit;
  font-weight: 500;
  background: transparent;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  opacity: 0.9;
}

.ui-snackbar__action {
  text-decoration: underline;
  color: inherit;
}

.ui-snackbar__action:hover,
.ui-snackbar__close:hover {
  opacity: 1;
  background: rgba(0, 0, 0, 0.06);
}

@media (max-width: 600px) {
  .ui-snackbar {
    right: 12px;
    width: calc(100vw - 24px);
  }

  .ui-snackbar__actions {
    justify-content: space-between;
  }
}

.ui-snackbar-enter-active,
.ui-snackbar-leave-active {
  transition:
    transform 0.2s ease,
    opacity 0.2s ease;
}
.ui-snackbar-enter-from,
.ui-snackbar-leave-to {
  transform: translateX(100%);
  opacity: 0;
}
</style>
